// eslint-disable-next-line import/prefer-default-export
export const menuList = [
  {
    id: 'workflow',
    name: 'WORKFLOW',
  },
];
